import React, { Component } from 'react'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Grid from '@material-ui/core/Grid'
import { Title } from '../../components/Generic'
import { saveAs } from 'file-saver'

import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import DownloadIcon from '@material-ui/icons/CloudDownload'
import moment from 'moment'

const PUBLIC_DB_DOWNLOAD_URL = `${process.env.API_URL}/api/v1/public-database-download/`

class DBBackup extends Component {

    constructor(props) {
        super(props)
    
        this.state = {
            downloading : false,
            error : false,
        }
        this.downloadPublicDb = this.downloadPublicDb.bind(this)
    }
    
    downloadPublicDb(){
        this.setState({ downloading : true, error : false })
        fetch(PUBLIC_DB_DOWNLOAD_URL, {
            headers: {
              'Content-Type': 'application/gzip'
            },
            responseType: 'blob'
        })
        .then(response => {
            return response.blob()
        })
        .then(blob => {
            let filename = `activos-tx-db-${moment().format("YYYYDDMMmmss")}.gz`
            this.setState({ downloading : false })
            saveAs(blob, filename)
        })
        .catch(error => {
            console.error(error)
            this.setState({ downloading : true, error : true })
        })

    }

    render(){

        const { downloading, error } = this.state

        return (
            <Card>
                <Title title="Descargar Base de Datos" />
                <CardContent>

                    <Grid container spacing={16}>
                        <Grid item xs={12} md={6}>
                            {error && <span>Error descargando la Base de Datos</span>}
                            {!downloading ?
                            <Button color="primary" onClick={this.downloadPublicDb}>
                                <DownloadIcon style={{ marginRight: '5px' }}/> Descargar Base de Datos Pública
                            </Button>
                            : 
                            <div>
                                <CircularProgress color="primary"/> <span>Descargando Base de Datos</span>
                            </div>
                            }
                            
                        </Grid>
                    </Grid>


                </CardContent>
            </Card>
        )
    }
}

export default DBBackup